// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "../EnumHelperFuncs";
export var StorageType = (/*@__PURE__*/createEnumStyle({
    LocalStorage: 0 /* eStorageType.LocalStorage */,
    SessionStorage: 1 /* eStorageType.SessionStorage */
}));
export var DistributedTracingModes = (/*@__PURE__*/createEnumStyle({
    AI: 0 /* eDistributedTracingModes.AI */,
    AI_AND_W3C: 1 /* eDistributedTracingModes.AI_AND_W3C */,
    W3C: 2 /* eDistributedTracingModes.W3C */,
    AI_AND_W3C_TRACE: 17 /* eDistributedTracingModes.AI_AND_W3C_TRACE */,
    W3C_TRACE: 18 /* eDistributedTracingModes.W3C_TRACE */,
    // Internal mask values
    _BaseMask: 15 /* eDistributedTracingModes._BaseMask */,
    _W3CTraceState: 16 /* eDistributedTracingModes._W3CTraceState */
}));
/**
 * The EventPersistence contains a set of values that specify the event's persistence.
 */
export var EventPersistence = (/*@__PURE__*/createEnumStyle({
    /**
     * Normal persistence.
     */
    Normal: 1 /* EventPersistenceValue.Normal */,
    /**
     * Critical persistence.
     */
    Critical: 2 /* EventPersistenceValue.Critical */
}));
//# sourceMappingURL=Enums.js.map